import React, { useRef, useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { gsap } from 'gsap';

// Email Form Endpoint - Now using environment variables
const EMAIL_ENDPOINT = process.env.REACT_APP_EMAIL_ENDPOINT;
const WHATSAPP_NUMBER = process.env.REACT_APP_WHATSAPP_NUMBER;

const ContactPage = () => {
  const cardRef = useRef(null);
  const formRef = useRef(null);
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    birthdate: '',
    message: '',
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState(null);



  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const sendToEmail = async (data) => {
    try {
      const response = await fetch(EMAIL_ENDPOINT, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({
          ...data,
          _subject: `New Astrology Inquiry from ${data.name}`,
          _template: 'table',
          timestamp: new Date().toLocaleString('en-IN', { timeZone: 'Asia/Kolkata' }),
        }),
      });
      return response.ok; // Returns true if status is 200-299
    } catch (error) {
      console.error('Error sending email:', error);
      return false;
    }
  };

  // eslint-disable-next-line no-unused-vars
  const sendToWhatsApp = (data) => {
    const message = `🔮 *புதிய ஜோதிட ஆலோசனை கோரிக்கை*

👤 *பெயர்:* ${data.name}
📧 *Email:* ${data.email}
📱 *Phone:* ${data.phone}
🎂 *பிறந்த தேதி:* ${data.birthdate}

💬 *செய்தி:*
${data.message}

---
_ஸ்ரீ செல்வகணபதி ஜோதிடம் Website_`;

    const encodedMessage = encodeURIComponent(message);
    const whatsappUrl = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodedMessage}`;
    window.open(whatsappUrl, '_blank');
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitStatus(null);

    // Send Email
    const emailSuccess = await sendToEmail(formData);

    // Removed auto-WhatsApp trigger on form submit to allow user choice

    if (emailSuccess) {
      setSubmitStatus('success');
      setFormData({
        name: '',
        email: '',
        phone: '',
        birthdate: '',
        message: '',
      });
    } else {
      setSubmitStatus('error');
    }

    setIsSubmitting(false);
  };

  return (
    <motion.div
      className="relative min-h-screen px-4 py-20 overflow-hidden"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.5 }}
    >
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-start">

          {/* Contact Info Section */}
          <motion.div
            className="text-center lg:text-left pt-10"
            initial={{ opacity: 0, x: -50 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ delay: 0.3, duration: 0.8 }}
          >
            <h1
              className="text-4xl md:text-6xl font-display tracking-wider mb-4"
              style={{
                color: '#d4af37',
                textShadow: '0 0 40px rgba(212, 175, 55, 0.4)',
              }}
            >
              தொடர்பு கொள்ளுங்கள்
            </h1>
            <p
              className="text-xl font-body mb-2"
              style={{ color: 'rgba(212, 175, 55, 0.7)' }}
            >
              Contact Us
            </p>
            <p
              className="text-lg font-body italic mb-12"
              style={{ color: 'rgba(192, 192, 192, 0.8)' }}
            >
              ஜோதிட ஆலோசனைக்கு இப்போதே தொடர்பு கொள்ளுங்கள்
            </p>

            {/* Address Details */}
            <div className="space-y-8">
              {/* Address */}
              <div
                className="p-6 rounded-2xl"
                style={{
                  background: 'rgba(255, 255, 255, 0.03)',
                  border: '1px solid rgba(212, 175, 55, 0.1)',
                }}
              >
                <h3 className="text-xl font-display mb-3" style={{ color: '#d4af37' }}>முகவரி / Address</h3>
                <p className="font-body text-lg leading-relaxed" style={{ color: 'rgba(230, 230, 230, 0.8)' }}>
                  Gandhi Nagar, Kannankurichi Main Road,<br />
                  Kannankurichi, Salem-636008,<br />
                  Tamil Nadu
                </p>
              </div>

              {/* Contact Methods */}
              <div
                className="p-6 rounded-2xl"
                style={{
                  background: 'rgba(255, 255, 255, 0.03)',
                  border: '1px solid rgba(212, 175, 55, 0.1)',
                }}
              >
                <h3 className="text-xl font-display mb-4" style={{ color: '#d4af37' }}>தொடர்புக்கு / Contact</h3>

                <div className="space-y-4">
                  <div className="flex items-center gap-4 justify-center lg:justify-start">
                    <span className="text-2xl">📞</span>
                    <div className="text-left">
                      <a href="tel:+919944428978" className="block text-lg hover:text-[#d4af37] transition-colors" style={{ color: '#e0e0e0' }}>
                        +91 99444 28978
                      </a>
                    </div>
                  </div>

                  <div className="flex items-center gap-4 justify-center lg:justify-start">
                    <span className="text-2xl">📧</span>
                    <a
                      href="mailto:astrology@selvaganapathyjothidam.com"
                      className="text-lg hover:text-[#d4af37] transition-colors"
                      style={{ color: '#e0e0e0' }}
                    >
                      astrology@selvaganapathyjothidam.com
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </motion.div>

          {/* Form Section */}
          <motion.div
            ref={cardRef}
            className="relative z-10 w-full"
            initial={{ opacity: 0, x: 50 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ delay: 0.5, duration: 1, ease: 'easeOut' }}
          >
            <div
              className="relative p-8 md:p-10 rounded-2xl"
              style={{
                background: 'linear-gradient(135deg, rgba(255, 255, 255, 0.05) 0%, rgba(255, 255, 255, 0.02) 100%)',
                backdropFilter: 'blur(20px)',
                WebkitBackdropFilter: 'blur(20px)',
                border: '1px solid rgba(212, 175, 55, 0.2)',
                boxShadow: `
                  0 8px 32px rgba(0, 0, 0, 0.4),
                  0 0 60px rgba(212, 175, 55, 0.1),
                  inset 0 1px 0 rgba(255, 255, 255, 0.1)
                `,
              }}
            >
              {/* Decorative Corner Elements */}
              <div
                className="absolute top-4 left-4 w-8 h-8"
                style={{
                  borderTop: '1px solid rgba(212, 175, 55, 0.4)',
                  borderLeft: '1px solid rgba(212, 175, 55, 0.4)',
                }}
              />
              <div
                className="absolute top-4 right-4 w-8 h-8"
                style={{
                  borderTop: '1px solid rgba(212, 175, 55, 0.4)',
                  borderRight: '1px solid rgba(212, 175, 55, 0.4)',
                }}
              />
              <div
                className="absolute bottom-4 left-4 w-8 h-8"
                style={{
                  borderBottom: '1px solid rgba(212, 175, 55, 0.4)',
                  borderLeft: '1px solid rgba(212, 175, 55, 0.4)',
                }}
              />
              <div
                className="absolute bottom-4 right-4 w-8 h-8"
                style={{
                  borderBottom: '1px solid rgba(212, 175, 55, 0.4)',
                  borderRight: '1px solid rgba(212, 175, 55, 0.4)',
                }}
              />

              {/* Success/Error Messages */}
              {submitStatus === 'success' && (
                <motion.div
                  initial={{ opacity: 0, y: -10 }}
                  animate={{ opacity: 1, y: 0 }}
                  className="mb-6 p-4 rounded-lg text-center"
                  style={{
                    background: 'rgba(34, 197, 94, 0.2)',
                    border: '1px solid rgba(34, 197, 94, 0.4)',
                    color: '#4ade80',
                  }}
                >
                  ✓ செய்தி அனுப்பப்பட்டது! WhatsApp-ல் உறுதிப்படுத்தவும்.
                </motion.div>
              )}

              {submitStatus === 'error' && (
                <motion.div
                  initial={{ opacity: 0, y: -10 }}
                  animate={{ opacity: 1, y: 0 }}
                  className="mb-6 p-4 rounded-lg text-center"
                  style={{
                    background: 'rgba(239, 68, 68, 0.2)',
                    border: '1px solid rgba(239, 68, 68, 0.4)',
                    color: '#f87171',
                  }}
                >
                  ⚠ சேவையகத்தில் சிக்கல். WhatsApp மூலம் தொடர்பு கொள்ளவும்.
                </motion.div>
              )}

              {/* Form */}
              <form ref={formRef} onSubmit={handleSubmit} className="space-y-5">
                <FormInput
                  label="உங்கள் பெயர் / Your Name"
                  name="name"
                  type="text"
                  placeholder="பெயரை உள்ளிடவும்"
                  value={formData.name}
                  onChange={handleChange}
                  delay={0.6}
                  required
                />
                <FormInput
                  label="மின்னஞ்சல் / Email"
                  name="email"
                  type="email"
                  placeholder="email@example.com"
                  value={formData.email}
                  onChange={handleChange}
                  delay={0.7}
                />
                <FormInput
                  label="தொலைபேசி / Phone"
                  name="phone"
                  type="tel"
                  placeholder="+91 XXXXX XXXXX"
                  value={formData.phone}
                  onChange={handleChange}
                  delay={0.75}
                  required
                />
                <FormInput
                  label="பிறந்த தேதி / Birth Date"
                  name="birthdate"
                  type="date"
                  value={formData.birthdate}
                  onChange={handleChange}
                  delay={0.8}
                />
                <FormTextarea
                  label="உங்கள் செய்தி / Your Message"
                  name="message"
                  placeholder="உங்கள் கேள்விகளை பகிரவும்..."
                  value={formData.message}
                  onChange={handleChange}
                  delay={0.9}
                  required
                />
                <SubmitButton delay={1} isSubmitting={isSubmitting} />
              </form>

              {/* Direct WhatsApp Link */}
              <motion.div
                className="mt-6 text-center"
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ delay: 1.2 }}
              >
                <p style={{ color: 'rgba(192, 192, 192, 0.6)' }} className="text-sm mb-3">
                  அல்லது நேரடியாக WhatsApp-ல் தொடர்பு கொள்ளுங்கள்
                </p>
                <a
                  href={`https://wa.me/${WHATSAPP_NUMBER}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center gap-2 px-6 py-3 rounded-full font-display text-sm tracking-wider transition-all hover:scale-105"
                  style={{
                    background: 'linear-gradient(135deg, rgba(37, 211, 102, 0.3) 0%, rgba(37, 211, 102, 0.15) 100%)',
                    border: '1px solid rgba(37, 211, 102, 0.5)',
                    color: '#25d366',
                  }}
                >
                  <span>💬</span> WhatsApp Chat
                </a>
              </motion.div>
            </div>

            {/* Ambient glow behind card */}
            <div
              className="absolute inset-0 rounded-2xl pointer-events-none"
              style={{
                background: 'radial-gradient(circle at 50% 50%, rgba(212, 175, 55, 0.15) 0%, transparent 60%)',
                filter: 'blur(40px)',
                transform: 'translateZ(-50px)',
                zIndex: -1,
              }}
            />
          </motion.div>
        </div>
      </div>
    </motion.div>
  );
};

const FormInput = ({ label, name, type, placeholder, value, onChange, delay, required }) => {
  const inputRef = useRef(null);
  const containerRef = useRef(null);

  useEffect(() => {
    const input = inputRef.current;
    const container = containerRef.current;

    const handleFocus = () => {
      gsap.to(container, {
        boxShadow: '0 0 30px rgba(212, 175, 55, 0.3), inset 0 0 20px rgba(212, 175, 55, 0.1)',
        borderColor: 'rgba(212, 175, 55, 0.6)',
        duration: 0.4,
        ease: 'power2.out',
      });
    };

    const handleBlur = () => {
      gsap.to(container, {
        boxShadow: 'none',
        borderColor: 'rgba(212, 175, 55, 0.2)',
        duration: 0.4,
        ease: 'power2.out',
      });
    };

    input.addEventListener('focus', handleFocus);
    input.addEventListener('blur', handleBlur);

    return () => {
      input.removeEventListener('focus', handleFocus);
      input.removeEventListener('blur', handleBlur);
    };
  }, []);

  return (
    <motion.div
      initial={{ opacity: 0, x: -20 }}
      animate={{ opacity: 1, x: 0 }}
      transition={{ delay, duration: 0.6 }}
    >
      <label
        className="block mb-2 text-sm font-display tracking-wider"
        style={{ color: 'rgba(212, 175, 55, 0.8)' }}
      >
        {label} {required && <span style={{ color: '#f4d03f' }}>*</span>}
      </label>
      <div
        ref={containerRef}
        className="relative rounded-lg transition-all"
        style={{
          background: 'rgba(10, 10, 15, 0.6)',
          border: '1px solid rgba(212, 175, 55, 0.2)',
        }}
      >
        <input
          ref={inputRef}
          type={type}
          name={name}
          placeholder={placeholder}
          value={value}
          onChange={onChange}
          required={required}
          className="w-full px-4 py-3 bg-transparent outline-none font-body text-base"
          style={{
            color: '#e0e0e0',
            caretColor: '#d4af37',
          }}
        />
      </div>
    </motion.div>
  );
};

const FormTextarea = ({ label, name, placeholder, value, onChange, delay, required }) => {
  const textareaRef = useRef(null);
  const containerRef = useRef(null);

  useEffect(() => {
    const textarea = textareaRef.current;
    const container = containerRef.current;

    const handleFocus = () => {
      gsap.to(container, {
        boxShadow: '0 0 30px rgba(212, 175, 55, 0.3), inset 0 0 20px rgba(212, 175, 55, 0.1)',
        borderColor: 'rgba(212, 175, 55, 0.6)',
        duration: 0.4,
        ease: 'power2.out',
      });
    };

    const handleBlur = () => {
      gsap.to(container, {
        boxShadow: 'none',
        borderColor: 'rgba(212, 175, 55, 0.2)',
        duration: 0.4,
        ease: 'power2.out',
      });
    };

    textarea.addEventListener('focus', handleFocus);
    textarea.addEventListener('blur', handleBlur);

    return () => {
      textarea.removeEventListener('focus', handleFocus);
      textarea.removeEventListener('blur', handleBlur);
    };
  }, []);

  return (
    <motion.div
      initial={{ opacity: 0, x: -20 }}
      animate={{ opacity: 1, x: 0 }}
      transition={{ delay, duration: 0.6 }}
    >
      <label
        className="block mb-2 text-sm font-display tracking-wider"
        style={{ color: 'rgba(212, 175, 55, 0.8)' }}
      >
        {label} {required && <span style={{ color: '#f4d03f' }}>*</span>}
      </label>
      <div
        ref={containerRef}
        className="relative rounded-lg transition-all"
        style={{
          background: 'rgba(10, 10, 15, 0.6)',
          border: '1px solid rgba(212, 175, 55, 0.2)',
        }}
      >
        <textarea
          ref={textareaRef}
          name={name}
          placeholder={placeholder}
          value={value}
          onChange={onChange}
          required={required}
          rows={4}
          className="w-full px-4 py-3 bg-transparent outline-none font-body text-base resize-none"
          style={{
            color: '#e0e0e0',
            caretColor: '#d4af37',
          }}
        />
      </div>
    </motion.div>
  );
};

const SubmitButton = ({ delay, isSubmitting }) => {
  const buttonRef = useRef(null);

  useEffect(() => {
    const button = buttonRef.current;

    const handleMouseEnter = () => {
      gsap.to(button, {
        scale: 1.02,
        boxShadow: '0 0 40px rgba(212, 175, 55, 0.5), 0 0 80px rgba(212, 175, 55, 0.2)',
        duration: 0.3,
        ease: 'power2.out',
      });
    };

    const handleMouseLeave = () => {
      gsap.to(button, {
        scale: 1,
        boxShadow: '0 0 20px rgba(212, 175, 55, 0.3)',
        duration: 0.3,
        ease: 'power2.out',
      });
    };

    button.addEventListener('mouseenter', handleMouseEnter);
    button.addEventListener('mouseleave', handleMouseLeave);

    return () => {
      button.removeEventListener('mouseenter', handleMouseEnter);
      button.removeEventListener('mouseleave', handleMouseLeave);
    };
  }, []);

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ delay, duration: 0.6 }}
      className="pt-4"
    >
      <button
        ref={buttonRef}
        type="submit"
        disabled={isSubmitting}
        className="w-full py-4 rounded-lg font-display text-lg tracking-widest uppercase cursor-pointer transition-all disabled:opacity-50"
        style={{
          background: 'linear-gradient(135deg, rgba(212, 175, 55, 0.3) 0%, rgba(212, 175, 55, 0.15) 100%)',
          border: '1px solid rgba(212, 175, 55, 0.5)',
          color: '#d4af37',
          boxShadow: '0 0 20px rgba(212, 175, 55, 0.3)',
        }}
      >
        {isSubmitting ? 'அனுப்புகிறது...' : 'செய்தி அனுப்பு'}
      </button>
    </motion.div>
  );
};

export default ContactPage;
